import { render, staticRenderFns } from "./CellRendererApproval.vue?vue&type=template&id=35e2c146&"
import script from "./CellRendererApproval.vue?vue&type=script&lang=js&"
export * from "./CellRendererApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports